import type { PreloadedQuery } from 'react-relay';
import type { QueryParams } from '@jira/software__security-vulnerability-url-parameter-utils/src/QueryParams.types.tsx';
import { getGqlFiltersFromQueryParams } from '@jira/software__security-vulnerability-url-parameter-utils/src/getGqlFiltersFromQueryParams.tsx';
// eslint-disable-next-line jira/import-whitelist
import MAIN_SECURITY_PAGE_QUERY, {
	type SecurityPageRootQuery,
} from '@jira/software__security-page/src/__generated__/SecurityPageRootQuery.graphql.ts';
// eslint-disable-next-line jira/import-whitelist
import { createAri } from '@jira/platform__utils-ari/src/index.tsx';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type {
	RouterDataContext,
	ResourceStoreContext,
	RouterContext,
	RouteResource,
} from '@atlassian/react-resource-router';

const RESOURCE_TYPE_SECURITY = 'SOFTWARE_SECURITY';

const getNumberOfVulnerabilitiesToFetch = (): number => 40;

const getNumberOfSecurityContainersToFetch = (): number =>
	fg('jira-development-increase-security-container-limit') ? 1000 : 100;

let filters: ReturnType<typeof getGqlFiltersFromQueryParams> | undefined;
export const securityPageResource: RouteResource<
	PreloadedQuery<SecurityPageRootQuery, Record<string, unknown>>
> = createRelayResource<SecurityPageRootQuery>({
	type: RESOURCE_TYPE_SECURITY,
	getQuery(
		{ match: { params }, query, route: { name } }: RouterDataContext | RouterContext,
		{ tenantContext: { cloudId, activationId } }: ResourceStoreContext,
	) {
		const isSecRoute = name === 'software-security' || name === 'software-security-classic';
		// Set filters on initial call only and not on every query param change
		if (!filters && isSecRoute) {
			const connectionAri = createAri({
				resourceOwner: 'jira',
				resourceType: 'security-container',
				cloudId,
				activationId,
				resourceId: '',
			});
			// oxlint-disable-next-line typescript/consistent-type-assertions
			filters = getGqlFiltersFromQueryParams(query as QueryParams, connectionAri);
		}
		// Reset filters when navigating away from the security page
		if (!isSecRoute) {
			filters = undefined;
		}
		return {
			parameters: MAIN_SECURITY_PAGE_QUERY,
			options: {
				fetchPolicy: 'store-and-network',
			},
			variables: {
				cloudAri: createAri({
					resourceOwner: 'jira',
					resourceType: 'site',
					resourceId: cloudId,
				}),
				cloudId,
				projectKey: params.projectKey ?? '',
				numberOfVulnsToFetch: getNumberOfVulnerabilitiesToFetch(),
				getContainers: false,
				numberOfContainersToFetch: getNumberOfSecurityContainersToFetch(),
				filter: filters,
			},
		};
	},
});
